var SCROLL_THRESOLDS = [25,50,75,100];

/* P15 fix: elementText previously forwarded the full visible text of anything clicked,
   site-wide — including /account and /orders pages, where that text is the customer's own
   name, address and order lines, readable by any connected custom pixel. On customer-account
   routes the text is now withheld entirely; elsewhere it is capped at 200 characters.
   Classes, ids and URLs are still reported everywhere. */
var ZEN_PRIVATE_ROUTE = /^\/(account|orders|challenge)([\/?#]|$)/.test(location.pathname.replace(/^\/[a-z]{2}(?=\/)/, ''));
document.addEventListener("click", e => {
  var txt = "";
  if (!ZEN_PRIVATE_ROUTE && e.target.innerText) {
    txt = e.target.innerText.replaceAll("\n", "").slice(0, 200);
  }
  Shopify.analytics.publish("click", {
    event: "custom_click",
    event_source: "custom_pixel",
    elementClasses: e.target.classList.value ? e.target.classList.value : "",
    elementId: e.target.id ? e.target.id : "",
    elementText: txt,
    elementTarget: e.target.target ? e.target.target : "",
    elementUrl: e.target.href ? e.target.href : ""
  });
});

const thresholds = SCROLL_THRESOLDS, triggeredThresholds = new Set;
function debounce(e, t) { let l; return function(...r) { clearTimeout(l), l = setTimeout(() => e.apply(this, r), t) } }
function checkScrollThresholds() {
  let scrolled = window.scrollY || document.documentElement.scrollTop,
      scrollHeight = document.documentElement.scrollHeight,
      clientHeight = document.documentElement.clientHeight,
      scrollable = scrollHeight - clientHeight;
  /* P16 fix: when content fits the viewport, scrollable is 0 and the old code divided by it,
     yielding Infinity — one stray overscroll bounce recorded 25/50/75/100% in a single tick. */
  if (scrollable <= 0) return;
  let pct = Math.round(scrolled / scrollable * 100);
  if (!isFinite(pct)) return;
  thresholds.forEach(t => {
    pct >= t && !triggeredThresholds.has(t) && (Shopify.analytics.publish("scroll_depth", {
      event: "custom_scroll",
      event_source: "custom_pixel",
      scrollThreshold: t,
      scrollUnits: "percent",
      scrollDirection: "vertical"
    }), triggeredThresholds.add(t))
  })
}
window.addEventListener("scroll", debounce(checkScrollThresholds, 100), { passive: true });
